<template>
  <div class="monitor-page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <!-- Top Action/Search Bar -->
          <div class="monitor-header-bar">
      <div class="monitor-header-search">
        <div class="incidents-search-wrapper">
          <b-input-group>
            <b-input-group-prepend>
              <span class="input-group-text search-icon">
                <i class="icofont icofont-search-alt-2"></i>
              </span>
            </b-input-group-prepend>
            <b-form-input
              class="incidents-search-input"
              v-model="filter"
              placeholder="Search"
              type="search"
            ></b-form-input>
          </b-input-group>
        </div>
      </div>
      <div class="monitor-header-actions">
        <div class="monitor-header-action-group">
          <button class="monitor-header-action-btn" @click="open_bulk_action = true">
            <img src="@/assets/icons/bulk-action-icon.svg" alt="Bulk Action" class="monitor-header-action-icon" />
            Bulk Action
          </button>
          <button class="monitor-header-action-btn" @click="open_import_monitor = true">
            <img src="@/assets/icons/import-monitors.svg" alt="Import" class="monitor-header-action-icon" />
            Import
          </button>
          <button class="monitor-header-action-btn" @click="ExportMonitor()">
            <img src="@/assets/icons/export-monitors.svg" alt="Export" class="monitor-header-action-icon" />
            Export
          </button>
          <button class="monitor-header-action-btn add-monitor-btn" @click="add_monitor_modal = true">
            <img src="@/assets/icons/Add-monitor-short.svg" alt="Add Monitor" class="monitor-header-action-icon" />
            Add Monitor
          </button>
        </div>
      </div>
    </div>
    
            <div slot="with-padding">
              <b-row class="mt-3 cust-monitor-btn-cont sectionShowMobile">
                <b-col md="6" class="mt-2 mt-md-0 cus-btn-group">
                  <b-button-group class="btn-group-square custom-border-06 b-r-8 p-1">
                    <button class="btn custom-btn" :class="[activeButton === 'all' ? 'btn-dark' : 'text-dark']" @click="toggleActive('all')">All</button>
                    <button class="btn custom-btn" :class="[activeButton === 'up' ? 'up-bg' : 'text-dark']" @click="toggleActive('up')">Up</button>
                    <button class="btn custom-btn" :class="[activeButton === 'down' ? 'down-bg' : 'text-dark']" @click="toggleActive('down')">Down</button>
                    <button class="btn custom-btn" :class="[activeButton === 'pause' ? 'pause-bg' : 'text-dark']" @click="toggleActive('pause')">Pause</button>
                  </b-button-group>
                </b-col>
                <b-col md="6">
                  <b-row >
                    <b-col >
                      <b-form-select
                          class="custom-border-06 b-r-8 custom-font-22 gray-font"
                          v-model="monitorType"
                          :options="monitor_type_opt"
                          @change="filterMonitorByType(monitorType)"
                        ></b-form-select>
                    </b-col>
                    <b-col class="text-right">
                      <b-form-group
                        label-cols="6"
                        label="Per page"
                        class="text-right custom-font-20 text-secondary border border-dark pr-0 pl-0 b-r-8 d-inline-block"
                        >
                        <b-form-select
                          class="custom-font-22 text-dark border-0 b-r-8"
                          v-model="perPage"
                          :options="pageOptions"
                          @change="setPerpage"
                          >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="col-md-12" v-if="loading">
                <h6 class="sub-title mb-0 text-center">Loading...</h6>
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
              </div> 
              <!-- Main Table Container -->
              <div v-else class="monitor-table-container">
                <!-- Filter Controls Row -->
                <div class="monitor-filter-controls">
                  <div class="monitor-status-group">
                    <button 
                      class="monitor-status-btn" 
                      :class="['first', { active: activeButton === 'all' } ]" 
                      @click="toggleActive('all')"
                    >
                      <img src="@/assets/icons/all-monitors-dark.svg" alt="All" class="status-icon" />
                      All
                    </button>
                    <button 
                      class="monitor-status-btn" 
                      :class="{ active: activeButton === 'up' }" 
                      @click="toggleActive('up')"
                    >
                      <img src="@/assets/icons/up-monitor-filter.svg" alt="Up" class="status-icon" />
                      Up
                    </button>
                    <button 
                      class="monitor-status-btn" 
                      :class="{ active: activeButton === 'down' }" 
                      @click="toggleActive('down')"
                    >
                      <img src="@/assets/icons/down-monitor-filter.svg" alt="Down" class="status-icon" />
                      Down
                    </button>
                    <button 
                      class="monitor-status-btn" 
                      :class="['last', { active: activeButton === 'pause' } ]" 
                      @click="toggleActive('pause')"
                    >
                      <img src="@/assets/icons/color-pause-icon.svg" alt="Pause" class="status-icon" />
                      Pause
                    </button>
                  </div>
                  <div class="filter-controls-right">
                    <div class="monitor-per-page-wrapper">
                      <img src="@/assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                      <span>Per page : </span>
                      <div class="select-wrapper">
                        <b-form-select
                          class="monitor-per-page-select"
                          v-model="perPage"
                          :options="pageOptions"
                          @change="setPerpage"
                        >
                        </b-form-select>
                        <svg class="select-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 10L12 15L17 10" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <div class="monitor-type-selector">
                      <div class="monitor-type-select-box">
                        <img src="@/assets/icons/monitor-selector.svg" alt="Monitor" class="monitor-type-icon" />
                        <div class="select-wrapper">
                          <b-form-select
                            class="monitor-select"
                            v-model="monitorType"
                            :options="monitor_type_opt"
                            @change="filterMonitorByType(monitorType)"
                          >
                            <template #first>
                            </template>
                          </b-form-select>
                          <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 10L12 15L17 10" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="datatable-vue table-responsive-custom">
                  <b-table
                    show-empty
                    stacked="md"
                    :items="items"
                    :fields="tablefields"
                    :filter="filter"
                    :per-page="perPage"
                    @filtered="onFiltered"
                    class="monitor-table"
                    borderless
                  >
                  <!-- <template #table-caption>Monitor List.</template> -->

                  <template #cell(index)="data">
                    <span class="monitor-index">{{ (currentPage - 1) * perPage + data.index + 1 }}</span>
                  </template>

                  <template #cell(name)="data">
                    <div class="monitor-name cust_txt" 
                         @click="openIncident(data.item)" 
                         :title="data.item.name"
                         style="cursor: pointer;">
                      {{ data.item.name }}
                    </div>
                  </template>
                
                  <template #cell(type)="data">
                    <span class="monitor-type">{{ getMonitorTypeText(data.item.type) }}</span>
                  </template>

                <template #cell(interval)="data">
                  <span v-if="data.item.dayCount && data.item.dayCount > 1">
                    {{ data.item.dayCount }} Days
                  </span>
                  <span v-else>{{ convertMsToHM(data.item.interval) }}</span>
                </template>
                <!-- <template #cell(createdAt)="data">
                  {{ new Date(data.item.createdAt).toLocaleDateString() }} - {{new Date(data.item.createdAt).toTimeString().substring(0, new Date(data.item.createdAt).toTimeString().indexOf("GMT"))}}
                </template> -->

                  <template #cell(monitoring)="data">
                    <div class="monitoring-badge-wrapper">
                      <span v-if="!data.item.status" class="monitoring-badge pause">
                        <img src="@/assets/icons/color-pause-icon.svg" alt="Paused" class="monitoring-badge-icon" />
                        Pause
                      </span>
                      <span v-else-if="data.item.isDown" class="monitoring-badge down">
                        <img src="@/assets/icons/color-down-icon.svg" alt="Down" class="monitoring-badge-icon" />
                        Down
                      </span>
                      <span v-else class="monitoring-badge up">
                        <img src="@/assets/icons/color-up-icon.svg" alt="Up" class="monitoring-badge-icon" />
                        Up
                      </span>
                    </div>
                  </template>
                  <template #cell(url)="data">
                    <div class="res_text" @click="CopyHearbeatUrl(data.item.type == 5 ? heartbeat_url + data.item._id : data.item.url)" title="Click to copy">
                      <span v-if="data.item.type == 5">{{ heartbeat_url + data.item._id }}</span>
                      <span v-else>{{ data.item.url }}</span>
                    </div>
                  </template>

                  <template #cell(status)="data">
                    <div class="status-toggle">
                      <label class="switch">
                        <input type="checkbox" :checked="data.item.status" @change="statusUpdate(data.item)">
                        <span class="slider round" :class="data.item.status ? 'active' : ''"></span>
                      </label>
                    </div>
                  </template>

                  <template #cell(action)="data">
                    <div class="action-buttons">
                      <button class="action-btn" @click="deleteMonitor(data.item._id)" title="Delete">
                        <img src="@/assets/icons/delete-icon.svg" alt="Delete" class="action-icon" />
                      </button>
                      <button class="action-btn" @click="editMonitor(data.item)" title="Edit">
                        <img src="@/assets/icons/edit-icon.svg" alt="Edit" class="action-icon" />
                      </button>
                      <button class="action-btn" @click="openMonitoReport(data.item)" title="Report">
                        <img src="@/assets/icons/view-modal-icon.svg" alt="Report" class="action-icon" />
                      </button>
                    </div>
                  </template>
                  </b-table>
                </div>
                <!-- Pagination -->
                <div class="pagination-wrapper">
                  <pagination-component
                    v-if="items.length > 0 || totalRowsCount > 0"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount || totalRows"
                    :page-options="pageOptions"
                    @change-page="handlePageChange"
                    @update-per-page="handlePerPageChange"
                  />
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-monitor" size="lg" title="" class="theme-modal custom-modal" @hidden="closeModal" v-model="add_monitor_modal" no-close-on-backdrop hide-footer>
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">{{ edit_monitor ? 'Edit Monitor' : 'Create Monitor' }}</h5>
            <button class="custom-modal-close" @click="closeModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>
        <add-monitor :add_monitor_modal="add_monitor_modal" @monitormodal="closeModal" :edit_monitor="edit_monitor" :monitor_data="monitor_data"></add-monitor>
        <!-- <template #modal-footer>
        <b-button @click="closeModal()" color="danger">Close</b-button>
        </template> -->
      </b-modal>

      <!-- Bulk Action Modal Start -->
      <b-modal id="modal-monitor" title="" @hidden="closeBulkModal" size="lg" class="theme-modal custom-modal" v-model="open_bulk_action" no-close-on-backdrop hide-footer>
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">Bulk Action</h5>
            <button class="custom-modal-close" @click="closeBulkModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>
        <bulk-action :open_bulk_action="open_bulk_action" @bulkmodal="closeBulkModal()"></bulk-action>
        <!-- <template #modal-header>
          <h5 class="font-weight-bold"><i class="fa fa-edit"></i> Bulk Actions</h5>
        </template> -->
        <!-- <template #modal-footer>
        <b-button @click="closeBulkModal()" color="danger">Close</b-button>
        </template> -->
      </b-modal>
      <!-- Bulk Action Modal End -->


      <!-- Import Monitor Modal -->
      <b-modal 
        id="import-monitor" 
        size="lg" 
        title="" 
        class="theme-modal custom-modal" 
        v-model="open_import_monitor" 
        no-close-on-backdrop 
        hide-footer
      >
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">Import Monitors</h5>
            <button class="custom-modal-close" @click="open_import_monitor = false" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>
        <import-monitor 
          :is-open="open_import_monitor" 
          @upload-success="handleImportSuccess"
        />
        <!-- No footer -->
      </b-modal>
      
      <!-- Monitor Report modal start  -->
      <b-modal id="monitor-report" size="xl" title="" class="theme-modal custom-modal" v-model="open_monitor_report" hide-footer>
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">Monitor Report - <span class="text-info">{{ monitor_data.name }}</span></h5>
            <button class="custom-modal-close" @click="open_monitor_report = false" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>
        <monitor-report :monitor_id="monitor_id" :monitor_data="monitor_data"></monitor-report>
      </b-modal>
      <!-- Monitor Report modal End  -->

      <!-- Incident Modal start  -->
      <b-modal id="incidentModal" size="xl" title="" class="theme-modal custom-modal" v-model="open_incident" hide-footer>
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">Incidents</h5>
            <button class="custom-modal-close" @click="open_incident = false" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>
        <incedent-vue :monitor_id="monitor_id" :monitor_data="monitor_data"></incedent-vue>
      </b-modal>
      <!-- Incident Modal End  -->
  </div>
</template>


<script>
import MonitorsController from "../../services/monitorController";
import HelperFunction from "../../services/helperFunction";
import Config from "../../services/config";
import AddMonitor from "./AddMonitor.vue";
import { monitorEvents } from '@/plugins/posthog-events';
import BulkAction from "./BulkAction.vue";
import SampleCsv from "../../services/sampleCsvData";
import MonitorReport from "./MonitorReport.vue";
import IncedentVue from "./Incedent.vue";
import PaginationComponent from "../components/PaginationComponent.vue";
import ImportMonitor from "../components/ImportMonitor.vue";
export default {
    name: "Monitor",
    components:{AddMonitor, BulkAction, MonitorReport,IncedentVue, PaginationComponent, ImportMonitor},
  data() {
    return {
        open_incident:false,
        monitor_id:'',
        monitor_data:[],
        open_monitor_report:false,
        monitorType:'all',
        activeButton: 'all',
        open_bulk_action:false,
        open_import_monitor:false,
        heartbeat_url :'',
        hearbeat_modal:false,
        add_monitor_modal:false,
        edit_monitor: false,
        tablefields: [
          { key: "index", label: "Sr.", sortable: false },
          { key: "name", label: "Name", sortable: true },
          { key: "type", label: "Type", sortable: false },
          { key: "monitoring", label: "Monitoring", sortable: false },
          { key: "url", label: "URL", sortable: false },
          { key: "interval", label: "Interval", sortable: false },
          { key: "status", label: "Status", sortable: false },
          { key: "action", label: "Action", sortable: false },
        ],
      items:[],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [10, 20, 50, 100],
      monitor_data:{},
      loading: false,
      monitor_type_opt: [
        { value: 'all', text: 'All Monitors' },
        { value: '1', text: 'HTTP(s)' },
        { value: '2', text: 'Keyword' },
        { value: '3', text: 'Ping' },
        { value: '4', text: 'Port' },
        { value: '5', text: 'Heartbeat' },
        { value: '6', text: 'Page Speed' },
        { value: '7', text: 'Page Screenshot' }
      ],
      sampleDatafields:[],
      sampleData:[],
      all_monitors:[],
      totalRowsCount: 0,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    isMobileScreen() {
        return window.innerWidth <= 1200;
    }
  },
  watch:{
    $route (to, from){
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if(urlParams.get('event')){
          this.add_monitor_modal = true
      }
    },
  },
  mounted() {
    if(this.$root.$data.showAddMoinitor == true){
      this.add_monitor_modal = true
    }
    this.$root.$data.showAddMoinitor = false
    this.heartbeat_url = Config.hertbeatUrl
    if(this.$route.query.type){
      this.activeButton = this.$route.query.type
    }

    this.sampleDatafields = SampleCsv.sampleDatafields
    this.sampleData = SampleCsv.sampleData
    this.getMonitors();
  },
  methods: {
    handleImportSuccess() {
      this.open_import_monitor = false;
      this.getMonitors();
    },
    openMonitoReport(data){
      this.monitor_id = data._id
      this.monitor_data = data
      this.open_monitor_report = true
    },
    openIncident(data){
      this.monitor_id = data._id
      this.monitor_data = data
      this.open_incident = true
    },
    closeModal(){
      this.add_monitor_modal = false
      this.edit_monitor = false;
      if(this.$router.history.current.fullPath != '/app/monitor'){
      this.$router.replace("/app/monitor");
      }
      this.getMonitors();
    },
    closeBulkModal(){
      this.open_bulk_action = false
      this.getMonitors();
    },
   async deleteMonitor(id){
    if(confirm("Are you sure want to delete?")){
      let response = await MonitorsController.deleteMonitor({"mid": id});
      if(response.result){
        // Track monitor deletion in PostHog
        monitorEvents.deleted(id);
        this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
        // this.getMonitors()
        this.items = this.items.filter((t)=> t._id !== id)
      }
      else{
          this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
          this.getMonitors()
      }
    }
    },
    editMonitor(data){
      this.add_monitor_modal = false
      this.add_monitor_modal = true
      this.monitor_data = data;
      this.edit_monitor = true;
    },
    async getMonitors() {
      var paginationQuery = '&currentPage='+this.currentPage+'&pageSize='+this.perPage

      if(this.monitorType != 'all'){
        this.filterMonitorByType(this.monitorType+paginationQuery)
        return
      }
      this.loading = true;
      this.items = [];
      this.all_monitors = []
      let response = await MonitorsController.getMonitors('?type='+this.activeButton+paginationQuery);
      console.log('Monitors API Response:', response); // Debug log
      if (response.result) {
        this.items = response.data;
        this.all_monitors = this.items
        // totalRows should be the count of current page items
        this.totalRows = this.items.length;
        // totalRowsCount should be the total count across all pages
        this.totalRowsCount = response.totalCount || response.total || response.count || 0;
        console.log('Monitors - Items:', this.items.length, 'Total Count:', this.totalRowsCount); // Debug log
        
        // If API doesn't return total count and we have a full page, assume there might be more
        if (!this.totalRowsCount && this.items.length === this.perPage) {
            // Set a high number to enable next button
            this.totalRowsCount = this.currentPage * this.perPage + 1;
        } else if (!this.totalRowsCount) {
            // If less than perPage items, this is likely the last page
            this.totalRowsCount = (this.currentPage - 1) * this.perPage + this.items.length;
        }
      }
      this.loading = false;
    },
    async filterMonitorByType(monitorType) {
      if(monitorType == 'all'){
        this.getMonitors()
        return
      }
      this.loading = true;
      this.items = []
      this.all_monitors = []
      let response = await MonitorsController.getMonitors('?monitortype='+monitorType);
      console.log('Monitors Filter API Response:', response); // Debug log
      if (response.result) {
        this.items = response.data;
        this.all_monitors = this.items
        // totalRows should be the count of current page items
        this.totalRows = this.items.length;
        // totalRowsCount should be the total count across all pages
        this.totalRowsCount = response.totalCount || response.total || response.count || 0;
        console.log('Monitors Filter - Items:', this.items.length, 'Total Count:', this.totalRowsCount); // Debug log
        
        // If API doesn't return total count and we have a full page, assume there might be more
        if (!this.totalRowsCount && this.items.length === this.perPage) {
            // Set a high number to enable next button
            this.totalRowsCount = this.currentPage * this.perPage + 1;
        } else if (!this.totalRowsCount) {
            // If less than perPage items, this is likely the last page
            this.totalRowsCount = (this.currentPage - 1) * this.perPage + this.items.length;
        }
      }
      this.sortMonitor(this.activeButton)
      this.loading = false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async statusUpdate(data){
        // this.loading = true;
        var s = true
        if(data.status == true){
            s = false
        }
        if (data.status == false) {
          data.status = true;
        } else {
          data.status = false;
        }
        var payload = {"mname":data.name,"mid": data._id, "status":s }
        let response = await MonitorsController.statusChange(payload)
        if(response.result){
            // Track monitor pause/resume in PostHog
            if (s) {
              monitorEvents.resumed(data._id);
            } else {
              monitorEvents.paused(data._id);
            }
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
        }
        else{
          this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
          this.getMonitors()
        }
      },
    CopyHearbeatUrl(str){
          const el = document.createElement('textarea');
          el.addEventListener('focusin', e => e.stopPropagation());
          el.value = str;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          this.$toasted.show('URL copied to clipboard.', {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
    },
    async ExportMonitor() {
      try {
        let path = `?type=${this.activeButton || ''}&monitortype=${this.monitorType || ''}&currentPage=${this.currentPage}&pageSize=${this.perPage}`;

        let response = await MonitorsController.exportMonitor(path);

        if (response.message) {
          this.$toasted.show(response.message, {
            theme: 'outline',
            position: 'bottom-center',
            type: 'error',
            duration: 3000
          });
          return;
        }

        let blob = new Blob([response], { type: 'application/octet-stream' });
        let downloadUrl = URL.createObjectURL(blob);

        let link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'monitors.csv';
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);

        this.$toasted.show('Monitor Exported', {
          theme: 'outline',
          position: 'bottom-center',
          type: 'success',
          duration: 2000
        });

      } catch (error) {
        this.$toasted.show('Something went wrong: ' + error.message, {
          theme: 'outline',
          position: "bottom-center",
          type: 'error',
          duration: 3000
        });
      }
    },

   convertMsToHM(millis) {
    return HelperFunction.convertMsToHM(millis*60*1000)
    },
    toggleActive(button) {
        this.activeButton = button;
        if(this.monitorType == 'all'){
          this.getMonitors();
        }
        else{
          this.sortMonitor(button)
        }
    },
    sortMonitor(txt){
      switch(txt){
        case 'up':
          this.items = this.all_monitors.filter((t)=> !t.isDown && t.status)
          break;
        case 'down':
          this.items = this.all_monitors.filter((t)=> t.isDown && t.status)
          break;
        case 'pause':
          this.items = this.all_monitors.filter((t)=> !t.status)
          break;
        default: 
          this.items = this.all_monitors
          break;
      }
    },
    setPerpage(){
      this.currentPage = 1;
      this.getMonitors();
    },
    downloadSampleData(){
      HelperFunction.downloadCSV(this.sampleData)
    },
    getMonitorTypeText(type) {
      const monitor = this.monitor_type_opt.find(m => m.value == type);
      return monitor ? monitor.text : 'Unknown';
    },
    handlePageChange(direction) {
      if (direction === 'prev' && this.currentPage > 1) {
        this.currentPage--;
      } else if (direction === 'next') {
        this.currentPage++;
      } else if (typeof direction === 'number') {
        this.currentPage = direction;
      }
      this.getMonitors();
    },
    handlePerPageChange(perPage) {
      this.perPage = perPage;
      this.currentPage = 1;
      this.getMonitors();
    }
  },
};
</script>

<style scoped>
.monitor-page-wrapper {
  width: 100%;
  padding: 0;
}

/* Monitor Table Container */
.monitor-table-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 0;
  overflow: hidden;
  margin: 0 0 20px 0;
  width: 100%;
}

/* Pagination wrapper */
.pagination-wrapper {
  background: #FFFFFF;
  border-radius: 0 0 20px 20px;
}

/* Filter Controls */
.monitor-filter-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #E5E7EB;
  background: #FFFFFF;
}

.filter-buttons-group {
  display: flex;
  gap: 12px;
}

.filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
}

.filter-btn:hover {
  background: #F9FAFB;
}

.filter-btn.active {
  background: #101828;
  color: #FFFFFF;
  border-color: #101828;
}

.filter-btn.active.status-up {
  background: #10B981;
  border-color: #10B981;
}

.filter-btn.active.status-down {
  background: #EF4444;
  border-color: #EF4444;
}

.filter-btn.active.status-pause {
  background: #6B7280;
  border-color: #6B7280;
}

.status-icon {
  width: 16px;
  height: 16px;
}

.filter-controls-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Per Page Styles - matching Incidents page */
.monitor-per-page-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 48px;
}

.monitor-per-page-wrapper .per-page-icon {
  width: 16px;
  height: 18px;
}

.monitor-per-page-wrapper .select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.monitor-per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.monitor-per-page-select:focus {
  box-shadow: none;
  outline: none;
}

.monitor-per-page-wrapper .select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
  font-size: 12px;
}

.monitor-select {
  padding: 8px 16px;
  background: #101828;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  min-width: 150px;
}

/* Monitor Table */
.monitor-table {
  margin-bottom: 0;
  width: 100%;
}

.monitor-table >>> thead th {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
  background: #FFFFFF;
}

.monitor-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  color: #161616;
  font-size: 16px;
  border-bottom: 1px solid #E5E7EB !important;
  vertical-align: middle;
}

.monitor-table >>> tbody tr:last-child td {
  border-bottom: none !important;
}

.monitor-table >>> tbody tr:hover {
  background-color: #F9FAFB;
}

/* Table Cell Styles */
.monitor-index {
  font-weight: 400;
  color: #3A3A3A;
}

.monitor-name {
  font-weight: 500;
  color: #0B6CFA;
  cursor: pointer;
}

.monitor-name:hover {
  text-decoration: underline;
}

.monitor-type {
  font-weight: 400;
  color: #3A3A3A;
}

.monitoring-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.monitoring-icon {
  width: 16px;
  height: 16px;
}

.status-text {
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
}

.status-text.status-up {
  color: #10B981;
}

.status-text.status-down {
  color: #EF4444;
}

.status-text.status-paused {
  color: #6B7280;
}

.monitor-url {
  font-weight: 400;
  color: #3A3A3A;
  cursor: pointer;
  word-break: break-all;
  max-width: 20em;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
}

.monitor-url:hover {
  color: #0B6CFA;
}

/* Status Toggle */
.status-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 44px;
  height: 24px;
  vertical-align: middle;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 75%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  height: 24px;
  background-color: #E5E7EB;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #10B981;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

/* Action Buttons */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #6B7280;
  font-size: 18px;
  transition: all 0.2s ease;
  border-radius: 4px;
}

.action-btn:hover {
  background: #F3F4F6;
  color: #374151;
}

.action-btn i {
  font-size: 18px;
}

.action-icon {
  width: 20px;
  height: 20px;
}

/* Keep existing styles */
.showMonitorBtn,
.sectionShowMobile {
 display: none !important;
}

.custom-border-06 {
  border: 0.6px solid rgba(0, 0, 0, 0.6) !important;
}

.add-monitor-btn-green-1 {
  font-size: 1.1vw;
  padding: 0.335rem 2.2em !important;
  background-color: #2FB234 !important;
  color: white !important;
  cursor: pointer !important;
  border-radius: 10px !important;
}

.add-monitor-btn-green-1:hover {
  background-color: #139818 !important;
}

/* .sectionShowDesktop .custom-btn-dark {
  margin-right: 1.5rem !important;
}

.sectionShowDesktop .custom-btn-dark:nth-child(3) {
  margin-right: 0.5rem !important;
} */

@media screen and (max-width: 1468px) {
  .add-monitor-btn-green-1 {
    padding: 0.333rem 1rem !important;
  }
}

@media screen and (max-width: 768px) {

  .btn-group-square {
    margin-bottom: 1rem !important;
    width: 100% !important;
  }

  .cus-btn-group .text-right{
    text-align: center !important;
  }

  .sectionShowMobile {
    display: block !important;
  }

  .sectionShowDesktop {
    display: none !important;
  }

  .sectionShowMobile .input-group-square .input-group > .form-control {
    padding-right: 5rem !important;
  }

  .add-monitor-btn-green-1 {
    font-size: 0.8rem !important;
    padding: 0.526rem 0.82rem !important;
    border-radius: 5px !important;
  }
}

@media screen and (max-width: 1200px) {
  .showMonitorBtn{
    display: block !important;
  }
  
  .monitor-filter-controls {
    flex-wrap: wrap;
    gap: 16px;
  }
  
  .filter-controls-right {
    flex-wrap: wrap;
    gap: 12px;
  }
}

/* Custom table responsive styles */
.table-responsive-custom {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Prevent horizontal scroll by adjusting column widths */
@media screen and (max-width: 1400px) {
  .monitor-table >>> thead th {
    font-size: 16px;
    padding: 12px 15px !important;
  }
  
  .monitor-table >>> tbody tr td {
    font-size: 14px;
    padding: 12px 15px !important;
  }
  
  .cust_txt {
    max-width: 7em;
  }
  
  .monitor-url {
    max-width: 12em;
  }
}

@media screen and (max-width: 1200px) {
  /* Hide interval column */
  .monitor-table >>> thead th:nth-child(6),
  .monitor-table >>> tbody td:nth-child(6) {
    display: none;
  }
  
  .monitor-table >>> thead th {
    font-size: 14px;
    padding: 10px 12px !important;
  }
  
  .monitor-table >>> tbody tr td {
    font-size: 13px;
    padding: 10px 12px !important;
  }
  
  .action-btn {
    width: 28px;
    height: 28px;
  }
  
  .action-icon {
    width: 16px;
    height: 16px;
  }
}

@media screen and (max-width: 992px) {
  /* Hide type column */
  .monitor-table >>> thead th:nth-child(3),
  .monitor-table >>> tbody td:nth-child(3) {
    display: none;
  }
  
  .monitor-url {
    max-width: 10em;
  }
  
  .cust_txt {
    max-width: 6em;
  }
  
  .monitoring-badge {
    font-size: 14px;
    padding: 3px 12px 3px 10px;
    min-width: 70px;
  }
  
  .monitoring-badge-icon {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 768px) {
  .monitor-filter-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .filter-buttons-group {
    flex-wrap: wrap;
    width: 100%;
  }
  
  .filter-controls-right {
    width: 100%;
    justify-content: space-between;
  }
  
  .monitor-select {
    width: 100%;
  }
  
  .monitor-per-page-wrapper {
    padding: 3px 12px;
    height: 40px;
    font-size: 13px;
  }
  
  .monitor-per-page-wrapper .per-page-icon {
    width: 14px;
    height: 16px;
  }
  
  .monitor-per-page-select {
    font-size: 13px;
    padding: 0 16px 0 4px;
  }
  
  /* Hide URL column on mobile */
  .monitor-table >>> thead th:nth-child(5),
  .monitor-table >>> tbody td:nth-child(5) {
    display: none;
  }
  
  /* Compact table styles */
  .monitor-table >>> thead th {
    font-size: 12px;
    padding: 8px 6px !important;
    white-space: nowrap;
  }
  
  .monitor-table >>> tbody tr td {
    font-size: 12px;
    padding: 8px 6px !important;
  }
  
  /* Smaller action buttons */
  .action-buttons {
    gap: 2px;
  }
  
  .action-btn {
    width: 24px;
    height: 24px;
  }
  
  .action-icon {
    width: 14px;
    height: 14px;
  }
  
  /* Smaller monitoring badge */
  .monitoring-badge {
    font-size: 11px;
    padding: 2px 8px 2px 6px;
    min-width: 55px;
  }
  
  .monitoring-badge-icon {
    width: 14px;
    height: 14px;
  }
  
  /* Smaller status toggle */
  .switch {
    width: 36px;
    height: 20px;
  }
  
  .slider:before {
    width: 14px;
    height: 14px;
    left: 2px;
    bottom: 3px;
  }
  
  input:checked + .slider:before {
    transform: translateX(16px);
  }
  
  .cust_txt {
    max-width: 5em;
  }
  
  .monitor-index {
    font-size: 11px;
  }
  
  /* Hide table responsive scroll on mobile when content fits */
  .table-responsive-custom {
    overflow-x: visible;
  }
}
.monitor-status-group {
  display: flex;
  background: #fff;
  border: 1px solid #D2E3FB;
  border-radius: 14px;
  padding: 5px;
  box-sizing: border-box;
}

.monitor-status-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: none;
  outline: none;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #101828;
  padding: 0px 28px !important;
  height: 44px;
  border-radius: 0;
  transition: all 0.2s ease;
  cursor: pointer;
  box-shadow: none;
}
.monitor-status-btn.first {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.monitor-status-btn.last {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  border-right: none;
}

/* Hover states - same as monitoring badges */
.monitor-status-btn:hover {
  border-radius: 12px;
}

/* All button hover */
.monitor-status-btn:nth-child(1):hover {
  background: #000000;
  color: #fcfdff;
}

/* Up button hover */
.monitor-status-btn:nth-child(2):hover {
  background: rgba(47, 178, 51, 0.10);
  color: #2FB233;
}

/* Down button hover */
.monitor-status-btn:nth-child(3):hover {
  background: rgba(231, 0, 0, 0.10);
  color: #E70000;
}

/* Pause button hover */
.monitor-status-btn:nth-child(4):hover {
  background: #F4F6F8;
  color: #344054;
}

/* Active states */
.monitor-status-btn.active {
  border-radius: 12px;
  border: none;
  position: relative;
  z-index: 1;
}

/* All button active - Black background */
.monitor-status-btn.active:nth-child(1) {
  background: #101828;
  color: #FFFFFF;
}

/* Up button active */
.monitor-status-btn:nth-child(2).active {
  background: rgba(47, 178, 51, 0.10);
  color: #2FB233;
}

/* Down button active */
.monitor-status-btn:nth-child(3).active {
  background: rgba(231, 0, 0, 0.10);
  color: #E70000;
}

/* Pause button active */
.monitor-status-btn:nth-child(4).active {
  background: #F4F6F8;
  color: #344054;
}
.monitor-status-btn .status-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  transition: all 0.2s ease;
}

/* Icon color changes - only for Up and Down buttons */
/* Up button - Green color on hover and active */
.monitor-status-btn:nth-child(2):hover .status-icon,
.monitor-status-btn:nth-child(2).active .status-icon {
  filter: brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%);
}

/* Down button - Red color on hover and active */
.monitor-status-btn:nth-child(3):hover .status-icon,
.monitor-status-btn:nth-child(3).active .status-icon {
  filter: brightness(0) saturate(100%) invert(13%) sepia(86%) saturate(7494%) hue-rotate(0deg) brightness(97%) contrast(115%);
}

/* All button - White icon when active and on hover (black background) */
.monitor-status-btn:nth-child(1):hover .status-icon,
.monitor-status-btn:nth-child(1).active .status-icon {
  filter: brightness(0) saturate(100%) invert(100%);
}

.monitor-type-select-box {
  display: flex;
  align-items: center;
  background: #EDF3FF;
  border-radius: 12px;
  padding: 0 12px;
  height: 48px;
  gap: 8px;
}

.monitor-type-icon {
  width: 22px;
  height: 22px;
}

.monitor-type-select-box .select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
}

.monitor-select {
  background: transparent;
  color: #101828;
  border: none;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  min-width: 120px;
  padding: 0 30px 0 8px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.monitor-type-select-box .monitor-select:focus {
  box-shadow: none;
  outline: none;
}

.monitor-type-select-box .dropdown-arrow {
  position: absolute;
  right: 8px;
  pointer-events: none;
  width: 20px;
  height: 20px;
}
.monitoring-badge-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.monitoring-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Inter', 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  border-radius: 999px;
  padding: 4px 18px 4px 12px;
  background: #F4F4F4;
  color: #101828;
  min-width: 80px;
  justify-content: center;
}
.monitoring-badge-icon {
  width: 22px;
  height: 22px;
  display: inline-block;
}
.monitoring-badge.up {
  background: rgba(47, 178, 51, 0.10);
  color: #2FB233;
}
.monitoring-badge.up .monitoring-badge-icon {
  filter: none;
}
.monitoring-badge.down {
  background: rgba(231, 0, 0, 0.10);
  color: #E70000;
}
.monitoring-badge.down .monitoring-badge-icon {
  filter: none;
}
.monitoring-badge.pause {
  background: #F4F6F8;
  color: #344054;
}
.monitoring-badge.pause .monitoring-badge-icon {
  filter: none;
}
.monitor-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  padding: 0;
  border-radius: 0;
  margin-bottom: 20px;
  margin-top: 30px;
  gap: 24px;
  width: 100%;
}
.monitor-header-search {
  flex: 1 1 0%;
  max-width: 480px;
}
.incidents-search-wrapper {
  position: relative;
}

.incidents-search-wrapper .input-group {
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  padding: 0px;
}

.incidents-search-wrapper .input-group-text {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px;
}

.incidents-search-wrapper .search-icon {
  color: #344054;
  font-size: 18px;
}

.incidents-search-input {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px 3px 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #111827;
}

.incidents-search-input:focus {
  box-shadow: none;
  background: transparent;
}

.incidents-search-input::placeholder {
  color: #9CA3AF;
}
.monitor-header-actions {
  display: flex;
  align-items: center;
  gap: 18px;
}
.monitor-header-action-group {
  display: flex;
  align-items: center;
  gap: 12px;
}
.monitor-header-action-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #101828;
  padding: 0 24px;
  height: 48px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  box-shadow: none;
}
.monitor-header-action-btn:hover {
  background: #F9FAFB;
}
.monitor-header-action-btn.add-monitor-btn {
  background: #2FB234;
  color: #fff;
  border-color: #2FB234;
  font-size: 18px !important;
}
.monitor-header-action-btn.add-monitor-btn:hover {
  background: #28A22C;
  border-color: #28A22C;
}
.monitor-header-action-icon {
  width: 22px;
  height: 22px;
  display: inline-block;
}
.add-monitor-btn-green {
  background: #2FB234 !important;
  color: #fff !important;
  border-radius: 12px !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  height: 54px !important;
  padding: 0 36px !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  border: none !important;
  box-shadow: none !important;
}
.add-monitor-btn-green img {
  width: 22px;
  height: 22px;
}

/* Additional responsive header styles */

/* Small laptop screens (1366x768 and similar) */
@media screen and (max-width: 1440px) {
  .monitor-header-bar {
    margin-top: 20px;
    margin-bottom: 16px;
    gap: 16px;
  }
  
  .monitor-header-search {
    max-width: 400px;
  }
  
  .incidents-search-input {
    font-size: 16px;
    padding: 2px 10px 2px 6px;
  }
  
  .incidents-search-wrapper .input-group {
    border-radius: 10px;
  }
  
  .incidents-search-wrapper .input-group-text {
    padding: 2px 10px;
  }
  
  .incidents-search-wrapper .search-icon {
    font-size: 16px;
  }
  
  .monitor-header-actions {
    gap: 12px;
  }
  
  .monitor-header-action-group {
    gap: 8px;
  }
  
  .monitor-header-action-btn {
    font-size: 14px;
    padding: 0 18px;
    height: 42px;
    gap: 8px;
    border-radius: 10px;
  }
  
  .monitor-header-action-icon {
    width: 18px;
    height: 18px;
  }
  
  /* Filter controls adjustments */
  .monitor-filter-controls {
    padding: 16px 20px;
  }
  
  .monitor-status-group {
    padding: 4px;
    border-radius: 12px;
  }
  
  .monitor-status-btn {
    font-size: 14px;
    padding: 0px 20px !important;
    height: 38px;
    gap: 8px;
  }
  
  .monitor-status-btn .status-icon {
    width: 16px;
    height: 16px;
  }
  
  .monitor-per-page-wrapper {
    height: 42px;
    padding: 8px 14px;
    font-size: 13px;
    border-radius: 10px;
  }
  
  .monitor-per-page-wrapper .per-page-icon {
    width: 14px;
    height: 16px;
  }
  
  .monitor-per-page-select {
    font-size: 13px;
  }
  
  .monitor-type-select-box {
    height: 42px;
    padding: 0 10px;
    gap: 6px;
    border-radius: 10px;
  }
  
  .monitor-type-icon {
    width: 18px;
    height: 18px;
  }
  
  .monitor-select {
    font-size: 14px;
    padding: 0 26px 0 6px;
  }
  
  .monitor-type-select-box .dropdown-arrow {
    width: 16px;
    height: 16px;
    right: 6px;
  }
  
  /* Monitoring badge adjustments */
  .monitoring-badge {
    font-size: 14px;
    padding: 3px 14px 3px 10px;
    min-width: 70px;
  }
  
  .monitoring-badge-icon {
    width: 18px;
    height: 18px;
  }
}

/* Medium laptop screens */
@media screen and (max-width: 1366px) {
  .monitor-header-bar {
    margin-top: 18px;
    margin-bottom: 14px;
    gap: 14px;
  }
  
  .monitor-header-search {
    max-width: 360px;
  }
  
  .incidents-search-input {
    font-size: 15px;
    padding: 2px 10px 2px 6px;
  }
  
  .monitor-header-action-btn {
    font-size: 13px;
    padding: 0 16px;
    height: 40px;
  }
  
  .monitor-header-action-icon {
    width: 16px;
    height: 16px;
  }
  
  .monitor-status-btn {
    font-size: 13px;
    padding: 0px 18px !important;
    height: 36px;
  }
  
  .monitor-status-btn .status-icon {
    width: 15px;
    height: 15px;
  }
  
  .monitor-per-page-wrapper {
    height: 40px;
    font-size: 12px;
  }
  
  .monitor-type-select-box {
    height: 40px;
  }
  
  .monitor-select {
    font-size: 13px;
  }
}

/* Tablet and smaller screens */
@media screen and (max-width: 768px) {
  .monitor-header-bar {
    flex-direction: column;
    padding: 12px;
    gap: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
  
  .monitor-header-search {
    max-width: 100%;
  }
  
  .monitor-header-actions {
    width: 100%;
  }
  
  .monitor-header-action-group {
    flex-wrap: wrap;
    width: 100%;
    gap: 8px;
  }
  
  .monitor-header-action-btn {
    font-size: 14px;
    padding: 0 16px;
    height: 44px;
    flex: 1;
    min-width: calc(50% - 4px);
  }
  
  .monitor-header-action-icon {
    width: 18px;
    height: 18px;
  }
}
</style>


<style>
/* Override Bootstrap table-responsive for monitor table */
.datatable-vue.table-responsive-custom {
  overflow-x: auto;
}

@media screen and (max-width: 768px) {
  .datatable-vue.table-responsive-custom {
    overflow-x: visible;
  }
  
  /* Force table to not exceed container width */
  .datatable-vue.table-responsive-custom .monitor-table {
    table-layout: fixed;
    width: 100%;
  }
}

.long_text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  width: 100%;border:none;background: none;resize: none;word-break: break-all;
}
.long_text:hover {
  resize: vertical;
}
.tooltip-inner{
  background-color: rgb(19, 1, 75) !important;
  color: rgb(255, 255, 255);
  width: 100%;
}
.glowing-dot-up {
  width: 10px;
  height: 10px;
  margin-top: 5px;
  border-radius: 50%;
  background-color: #86f700;
  box-shadow: 0 0 10px #86f700;
  animation: glowup 1s ease-in-out infinite;
}


@keyframes glowup {
  from {
    box-shadow: 0 0 5px #59ff00;
  }
  to {
    box-shadow: 0 0 10px #33ff00;
  }
}
.glowing-dot-down {
  width: 10px;
  height: 10px;
  margin-top: 5px;
  border-radius: 50%;
  background-color: #f70000;
  box-shadow: 0 0 10px #d72b1b;
  animation: glowdown 1s ease-in-out infinite;
}

@keyframes glowdown {
  from {
    box-shadow: 0 0 5px #ff4d00;
  }
  to {
    box-shadow: 0 0 10px #ff2f00;
  }
}
.glowing-dot-pause {
  width: 10px;
  height: 10px;
  margin-top: 5px;
  border-radius: 50%;
  background-color: #d6f700;
  box-shadow: 0 0 10px #d7d71b;
  animation: glowpause 1s ease-in-out infinite;
}

@keyframes glowpause {
  from {
    box-shadow: 0 0 5px #fbe555;
  }
  to {
    box-shadow: 0 0 10px #ddff00;
  }
}
.pause-bg{
  color: white;
  background-color: #818181 !important;
}
.pause-bg:hover{
  color: white;
}
.down-bg{
  color: white;
  background-color: #E70000 !important;
}
.down-bg:hover{
  color: white;
}
.up-bg{
  color: white;
  background-color: #188107 !important;
}
.up-bg:hover{
  color: white;
}

/* Custom Modal Styles - Similar to Verify Modal */
.custom-modal .modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
}

.custom-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  position: relative;
}

.custom-modal-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #161616;
  margin: 0;
  text-align: center;
}

.custom-modal-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.custom-modal-close:hover {
  background: #F3F4F6;
  color: #374151;
}

.custom-modal .modal-body {
  padding: 30px;
  font-family: 'Poppins', sans-serif;
}

</style>



